import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, CssVarsProvider, Sheet, Stack, Typography} from '@mui/joy';
import Demo from '../components/Demo';
import Profile from '../components/Profile';
import {ProjectRepository} from "../repository/ProjectRepository";
import {SummaryModel} from "../model/summary";
import Education from "../components/Education";
import {EducationModel} from "../model/education";
import {ExperienceModel} from "../model/experience";
import {ProjectModel} from "../model/project";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";
import Loading from "./Loading";
import LoadingPage from "./Loading";
import TimeOutPage from './TimeOut';
import Footer from "../components/Footer";
import SocialNetwork from "../components/SocialNetwork";
import Photo from "../components/Photo";
import Description from "../components/Description";
import ContactInfo from "../components/ContactInfo";


function BioPage() {
    const repo = new ProjectRepository()
    const [summary, setSummary] = useState<SummaryModel>(new SummaryModel());
    const [profileLight, setProfileLight] = useState<string>('');
    const [profileDark, setProfileDark] = useState<string>('');
    const [error, setError] = useState<boolean>(false);
    const dates = summary.dateOfBirth.split('-').map(value => Number(value));
    const date = new Date(dates[2], dates[1] - 1, dates[0]);
    const options = { year: "numeric", month: 'numeric', day: 'numeric' };

    const dateString = date.toDateString();
    const dateBirth = dateString.substring(dateString.indexOf(' '));
    useEffect(() => {

        repo.getSummary().then(value => {
            if (value.profile.length > 0) {
                setSummary(value);
            } else {
                setError(true);
            }
        });
        repo.getProfileDarkURL().then(value => {
            if (value.length > 0) {
                setProfileDark(value);
            } else {
                setError(true);
            }
        });
        repo.getProfileLightURL().then(value => {
            if (value.length > 0) {
                setProfileLight(value);
            } else {
                setError(true);
            }
        });

    }, [])
    return (
        <Box>
            <Sheet sx={{
                //minHeight: '67vh',
                paddingX: 4,
                paddingY: 4,
                alignItems: 'center',
                justifyContent: 'center'
            }}>

                {!(summary.profile.length > 0) && (
                    <LoadingPage/>
                )}
                {(summary.profile.length > 0 && error) && (
                    <TimeOutPage/>
                )}
                {(summary.profile.length > 0 && !error) && (
                    <Stack alignItems={{xs: 'center', md: 'flex-start'}}
                           justifyContent={{xs: 'center', md: 'space-between'}}
                           spacing={2}
                           paddingY={{md: 2}}
                           direction={{xs: 'column', md: 'row'}}>
                        <Stack alignItems={{xs: 'center', md: 'flex-start'}} justifyContent={{xs: 'center', md: 'space-between'}} padding={{xs: 0, md: 0}}>
                            <Typography textAlign={{md: "start", xs: "center"}} level='h4'>
                                {summary?.firstName.concat(" " + summary?.lastName)}
                            </Typography>
                            <Typography textAlign={{md: "start", xs: "center"}} style={{wordWrap: "normal"}}
                                        level='title-md'>
                                Born {dateBirth}
                            </Typography>
                            <br/>
                            <Photo profileLight={profileLight} profileDark={profileDark} animate={false}
                                   useAvatar={false}/>
                        </Stack>
                        <Stack width={16}/>
                        <Stack maxWidth='md' alignItems={{md: "start", xs: "center"}} sx={{padding: 0}}
                               direction='column'
                               spacing={{xs: 1, sm: 2, md: 4}}>
                            <Typography level='h2' fontWeight='bolder'>BIOGRAPHY</Typography>
                            <Typography style={{ whiteSpace: 'pre-line'}} textAlign={{md: "start", xs: "justify"}} >{summary?.about.replaceAll('\n','\n\n')}</Typography>
                            {/*<p  dangerouslySetInnerHTML={{__html: summary?.about.replaceAll('\n','<br/>')}}  textAlign={{md: "start", xs: "justify"}}/>*/}
                        </Stack>
                        <Stack width={16}/>
                    </Stack>
                )}
            </Sheet>
        </Box>
    );
}

export default BioPage;
